function alphabetically (a, b) {
    if (a.name === b.name) {
        return 0
    }

    return a.name > b.name ? 1 : -1
}

export default {
    currentChannel (state) {
        return state.currentUserChannels.find(channel => channel.id === state.currentChannelId)
    },

    activeCurrentUserChannels (state) {
        return state.currentUserChannels.filter(channel => channel.archived_at === null).sort(alphabetically)
    },

    activeChannels (state) {
        return state.channels.filter(channel => channel.archived_at === null).sort(alphabetically)
    },

    archivedChannels (state) {
        return state.channels.filter(channel => channel.archived_at !== null).sort(alphabetically)
    }
}
